<template>
  <div class="history-index">
    <div class="module-item-style">
      <div class="module-item-title">历史会话</div>
      <div class="module-item-tips">可查看所有访客与客服对话的历史记录</div>
    </div>
    <div class="module-item-style">
      <div class="history-search-container">
        <el-select v-model="serviceId" filterable placeholder="请选择" style="width: 110px;" @change="filterData">
          <el-option
              v-for="item in serviceList"
              :key="item.csId"
              :label="item.csName"
              :value="item.csId">
          </el-option>
        </el-select>
        <el-select v-model="tagId" filterable placeholder="请选择" style="width: 110px;" @change="filterData">
          <el-option
              v-for="item in tagsList"
              :key="item.tagId"
              :label="item.label"
              :value="item.tagId">
          </el-option>
        </el-select>
        <el-date-picker
            v-model="selectTime"
            type="daterange"
            @change="timeSelect"
            :picker-options="pickerOptions"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
        >
        </el-date-picker>

        <el-input placeholder="请输入访客昵称" style="width: 200px;" v-model="vistorName"
                  class="service-search-input">
          <el-button slot="append" icon="el-icon-search" @click="filterData"></el-button>
        </el-input>
        <div class="topSeach">
          <el-input placeholder="请输入查询聊天记录" style="width: 230px;" v-model="content"
                  class="service-search-input" @input="changeContent">
            <el-button slot="append" icon="el-icon-search" @click="seachChatData(1)"></el-button>
          </el-input>
          <div class="chatBox" v-show="chatShowPop">
              <div class="search-result-item">
              <ul class="search-result-list-box" v-if="searchRecordUserList.length > 0">
                <li class="search-result-list-item" v-for="(item,index) in searchRecordUserList" :key="index" @click="searchResultItem(item)">
                  <div class="search-result-avatar" :class="item.status == 'offline' ? 'off' : ''">
                    <img :src="avatarX(item.avatar)" alt />
                  </div>
                  <div class="search-result-content-box">
                    <p class="search-result-username chatting">{{item.nickname}}</p>
                    <p class="search-result-chat-content" v-html="$utils.utils_RenderMsgLeft(item.queryContent)"></p>
                    <p class="search-result-chat-time">
                      {{ $utils.uitls_time_formmat(item.messages !='' ?
                      item.messages[0].sendtime : '' )}}
                    </p>
                  </div>
                </li>
                <div style="text-align: center;line-height: 40px;" v-if="searchRecordNoMore">暂无更多数据</div>
                <div style="text-align: center;line-height: 40px;cursor: pointer;" @click="RecordSearchGetMore" v-else>加载更多</div>
              </ul>
              <ul class="search-result-list-box" v-else>
                <li class="search-result-list-item no-search-result">暂无相关结果</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="export-data-container" v-if="userAuth.is_history_export">
          <div class="wl-btn" @click="dialogExport" v-loading="dialogExportLoading">导出对话记录</div>
          <div class="wl-btn" @click="visitorInfoExport" v-loading="visitorExportLoading">导出访客信息</div>
        </div>
      </div>
    </div>
    <div class="module-item-style">
      <div class="history-table-box">
        <el-table
			ref="sort"
			@sort-change="sortChange" 
            :data="tableData"
            stripe
            v-loading="historyLoading"
            :header-cell-style="{background:'#f2f2f2'}"
            :class="{'chatCss':isShow,'EvaluationCss':isShowEvaluation}"
            style="width: 100%;border: 1px solid #ebeef5;font-size: 12px;">
          <el-table-column label="访客信息" :width="(!isShow && !isShowEvaluation) ? '400' : ''">
            <template slot-scope="scope">
              <el-popover
                  placement="bottom">
                <div class="visitor-info-container">
                  <div class="info-title">个人信息</div>
                  <div>
                    <!--<div class="info-item">-->
                    <!--<div class="item-label">姓名：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.name ? scope.row.visitorinfo.name : '未知'}}</div>-->
                    <!--</div>-->
                    <div class="info-item" :key="index" v-for="(item, index) in scope.row.visitorinfo.display">
                      <div class="item-left">
                        <div class="item-label">{{ item.fieldName }}：</div>
                        <div class="item-value">{{ renderSex(item.fieldName, item.fieldValue) || '--' }}</div>
                      </div>
                      <!--<div class="item-right">-->
                      <!--<div class="item-label">年龄：</div>-->
                      <!--<div class="item-value">{{scope.row.visitorinfo.age ? scope.row.visitorinfo.age : '&#45;&#45;'}}</div>-->
                      <!--</div>-->
                    </div>

                    <!--<div class="info-item">-->
                    <!--<div class="item-left">-->
                    <!--<div class="item-label">电话：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.phone ? scope.row.visitorinfo.phone : '&#45;&#45;'}}</div>-->
                    <!--</div>-->
                    <!--<div class="item-right">-->
                    <!--<div class="item-label">QQ：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.qq ? scope.row.visitorinfo.qq : '&#45;&#45;'}}</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="info-item">-->
                    <!--<div class="item-left">-->
                    <!--<div class="item-label">微信：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.wechat ? scope.row.visitorinfo.wechat : '&#45;&#45;'}}</div>-->
                    <!--</div>-->
                    <!--<div class="item-right">-->
                    <!--<div class="item-label">邮箱：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.email ? scope.row.visitorinfo.email : '&#45;&#45;'}}</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="info-item">-->
                    <!--<div class="item-label">地址：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.address ? scope.row.visitorinfo.address : '&#45;&#45;'}}</div>-->
                    <!--</div>-->
                    <!--<div class="info-item">-->
                    <!--<div class="item-label">备注：</div>-->
                    <!--<div class="item-value">{{scope.row.visitorinfo.remark ? scope.row.visitorinfo.remark : '&#45;&#45;'}}</div>-->
                    <!--</div>-->
                  </div>
                </div>
                <div slot="reference">
                  <div class="visit-info">
                    <div class="visit-info-left">
                      <div class="agentImg fl">
                        <img :src="avatarX(scope.row.onlineVisitorEntity.visitorHeadimg)" alt="">
                      </div>
                      <div class="item-info-wrapper">
                        <div
                            v-if="index < 3"
                            class="item-info" :key="index"
                            v-for="(item, index) in scope.row.visitorinfo.display">
                          <div class="item-label">{{ item.fieldName }}：</div>
                          <div class="item-value">{{ renderSex(item.fieldName, item.fieldValue) || '--' }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="visit-info-right">
                      <div class="info-wrap">
                        <!--<div class="wrap-display" :class="(!isShow && !isShowEvaluation) ? 'wrap-left-info' : ''">-->
                        <!--<span class="agentName">{{ scope.row.onlineVisitorEntity.visitorName }}</span>-->
                        <!--</div>-->
                        <div class="wrap-right-info" v-if="!isShow && !isShowEvaluation"><span>浏览器/设备：</span><span
                            class="visitorImg"><img
                            :src="avatarDev(scope.row.onlineVisitorEntity.visitorBrower)"></span><span
                            class="visitorImg"><img
                            :src="avatarSys(scope.row.onlineVisitorEntity.visitorEqu)"></span></div>
                      </div>
                      <div class="info-wrap">
                        <!--<div  class="wrap-display" :class="(!isShow && !isShowEvaluation) ? 'wrap-left-info' : ''">-->
                        <!--<span class="agentImg fl">-->
                        <!--</span>-->
                        <!--<span class="agentName">电话：{{scope.row.visitorinfo.phone ? scope.row.visitorinfo.phone : '&#45;&#45;'}}</span>-->
                        <!--</div>-->
                        <div class="wrap-right-info" v-if="!isShow && !isShowEvaluation">来源：
                          <div class="source">
                            <span class="source_from" :class="scope.row.visitorinfo.source_qk">{{ scope.row.visitorinfo.source_qk | formatSource}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="info-wrap">
                        <!--<div  class="wrap-display" :class="(!isShow && !isShowEvaluation) ? 'wrap-left-info' : ''">-->
                        <!--<span class="agentImg fl">-->
                        <!--</span>-->
                        <!--<span class="agentName">微信：{{scope.row.visitorinfo.wechat ? scope.row.visitorinfo.wechat : '&#45;&#45;'}}</span>-->
                        <!--</div>-->
                        <div class="wrap-right-info" v-if="!isShow && !isShowEvaluation">地区： <span>{{ scope.row.onlineVisitorEntity.visitorCity ? scope.row.onlineVisitorEntity.visitorCity : '&#45;&#45;' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-wrap">
                    <!--<div  class="wrap-display" :class="(!isShow && !isShowEvaluation) ? 'wrap-left-info' : ''">-->
                    <!--<span class="agentImg fl">-->
                    <!--</span>-->
                    <!--<span class="agentName">QQ：{{scope.row.visitorinfo.qq ? scope.row.visitorinfo.qq : '&#45;&#45;'}}</span>-->
                    <!--</div>-->
                  </div>
                </div>
              </el-popover>

            </template>
          </el-table-column>
          <el-table-column label="标签" min-width="90" class="tag" v-if="!isShow && !isShowEvaluation">
            <template slot-scope="scope">
              <span v-if="scope.row.tags.length == 0">--</span>
              <span v-else class="tag" :class="'tc-'+ tag.tagColor" v-for="(tag,index) in scope.row.tags"
                    :key="index">{{tag.onlineVisitorTagEntity.tagName}}</span>
            </template>
          </el-table-column>
		  <el-table-column label="客服回复数量"  width="100">
		    <template slot-scope="scope">
		      <div>{{scope.row.csAllCallData}}</div>
		    </template>
		  </el-table-column>
		  <el-table-column label="访客访问数量" sortable="custom" prop="visitNum" width="120">
		    <template slot-scope="scope">
		      <div>{{scope.row.visitorAllCallData}}</div>
		    </template>
		  </el-table-column>
          <el-table-column label="最后会话时间" v-if="!isShow && !isShowEvaluation" width="135" prop="callingEndTime"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{scope.row.callingEndTime.split(' ')[0]}}</div>
              <div>{{scope.row.callingEndTime.split(' ')[1]}}</div>
            </template>
          </el-table-column>
          <el-table-column label="咨询次数" v-if="!isShow && !isShowEvaluation" width="80" prop="consultNum">
          </el-table-column>
          <el-table-column label="最后接待客服" v-if="(!isShow && !isShowEvaluation) || isShowEvaluation" width="170"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="info-wrap">
                <span class="agentImg fl"><img :src="avatarM(scope.row.csHeadimg)" alt=""></span>
                <span class="agentName">{{ scope.row.csName }}</span>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="评价" v-if="!isShow || isShowEvaluation" width="150">
            <template slot-scope="scope">
              <div class="evaluater-rate" style="cursor: pointer;">
                <el-rate disabled disabled-void-color="#ddd" @click.native="evaluateHandleOperate(scope.row)"
                         score-template="{value}"
                         v-model="scope.row.evaluateGrade"></el-rate>
              </div>

            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" v-if="isShow || !isShowEvaluation" class="operate" width="100">
            <template slot-scope="scope">
              <el-popover
                  v-if="contactVisitorAuth"
                  placement="right"
                  width="140">
                <ul class="contact-visitor-box">
                  <li class="contact-visitor-item clearfix "
                      :class=" scope.row.visitorinfo.phone == '' ? 'cant-click' : ''"
                      @click="sendMsgToVisitorWay({type: 'dx',data: scope.row})" disabled>
                    <div class="contact-visitor-icon"><img src="@/assets/images/c-msg.png" alt=""
                                                           width="30" height="30"></div>
                    <div class="contact-visitor-title">短信</div>
                  </li>
                  <li class="contact-visitor-item clearfix"
                      :class="(scope.row.visitorinfo.source_qk != 'wxgzh' && scope.row.visitorinfo.source_qk !=
                      'wxapp') ? '' : 'cant-click'"
                      @click="sendMsgToVisitorWay({type: 'sc',data: scope.row})">
                    <div class="contact-visitor-icon"><img src="@/assets/images/c-service.png"
                                                           alt="" width="30" height="30"></div>
                    <div class="contact-visitor-title">商城信息</div>
                  </li>
                  <li class="contact-visitor-item clearfix"
                      :class="scope.row.visitorinfo.source_qk != 'wxgzh' ? 'cant-click' : ''"
                      @click="sendMsgToVisitorWay({type: 'gzh',data: scope.row})">
                    <div class="contact-visitor-icon"><img src="@/assets/images/c-wx.png" alt=""
                                                           width="30" height="30"></div>
                    <div class="contact-visitor-title">微信公众号信息</div>
                  </li>
                  <li class="contact-visitor-item clearfix"
                      :class="scope.row.visitorinfo.source_qk != 'wxapp' ? 'cant-click' : ''"
                      @click="sendMsgToVisitorWay({type: 'xcx',data: scope.row})">
                    <div class="contact-visitor-icon"><img src="@/assets/images/c-xcx.png" alt=""
                                                           width="30" height="30"></div>
                    <div class="contact-visitor-title">小程序信息</div>
                  </li>
                </ul>
                <span class="tb-btn tb-btn-operate" slot="reference">联系访客</span>
              </el-popover>
              <span @click="handleOperate(scope.row)" class="tb-btn tb-btn-operate"
                    style="margin-top: 10px;">查看记录</span>
			  <span v-if="!scope.row.blacklist.is_in_list" @click="addBlackList(scope.row.onlineVisitorEntity.visitorId)" class="tb-btn tb-btn-del"
				    style="margin-top: 10px;">加入黑名单</span>	
			  <span v-if="scope.row.blacklist.is_in_list" @click="removeBlackList(scope.row.onlineVisitorEntity.visitorId)" class="tb-btn tb-btn-del danger"
					style="margin-top: 10px;">移除黑名单</span>	
            </template>
          </el-table-column>
        </el-table>

        <!--    分页-->

        <pagenations
            :class="{'chatCss':isShow,'EvaluationCss':isShowEvaluation}"
            :total="total"
            :size="pageSize"
            :currentPage="currentPage"
            @pageHandler="pageOperate">
        </pagenations>
      </div>
    </div>
    <div class="pannelBox" v-if="isShow">
      <HistoryVisitorInfo :historyData="chatItem" @historyShowHandler="historyShowHandler"  @refreshVisitorInfo="refreshVisitorInfo"></HistoryVisitorInfo>
    </div>
    <div class="evaluatePannelBox" v-if="isShowEvaluation">
      <Evaluate :evaluateData="evaluateData" @evaluateShowHandler="evaluateShowHandler"></Evaluate>
    </div>
    <el-dialog
        :title="contactVisitorTitle"
        :visible.sync="contactVisitorVisible"
        width="30%">
      <p style="padding: 0 0 15px;color: #999;" v-if="visitorPhone.length != 0">该访客手机号码：<span
          style="color: #333;">{{visitorPhone}}</span></p>
      <textarea class="j-contact-visitor-content contact-visitor-content " v-model="sendMsgData.content" cols="30"
                rows="10"
                placeholder="请输入内容"></textarea>
      <span slot="footer" class="dialog-footer">
                <!--<el-button @click="contactVisitorVisible = false">取 消</el-button>-->
                <el-button type="primary" @click="sendMsgToVisitor">发 送</el-button>
              </span>
    </el-dialog>
  </div>
</template>

<script>
  import pagenations from '@/components/pagenations/pagenations'
  import HistoryVisitorInfo from './panel/historyVisitorInfo'
  import Evaluate from './panel/evaluate'
  // import Store from "@/utils/store";

  import avatar0 from '@/assets/images/client_avatar_empty.png'
  import avatar1 from '@/assets/images/client_avatar1.png'
  import avatar2 from '@/assets/images/client_avatar2.png'
  import avatar3 from '@/assets/images/client_avatar3.png'
  import avatar4 from '@/assets/images/client_avatar4.png'
  import avatar5 from '@/assets/images/client_avatar5.png'
  import avatar6 from '@/assets/images/client_avatar6.png'
  import avatar7 from '@/assets/images/client_avatar7.png'
  import device1 from '@/assets/images/chrome.png'
  import device2 from '@/assets/images/safari.png'
  import device3 from '@/assets/images/firefox.png'
  import device4 from '@/assets/images/ie.png'
  import device5 from '@/assets/images/wechat.png'
  import system1 from '@/assets/images/windows.png'
  import system2 from '@/assets/images/ios.png'
  import system3 from '@/assets/images/android.png'
  import unknown from '@/assets/images/unknown.png'
  import Cookies from 'js-cookie'
  export default {
    name: 'history-index',
    components: {
      pagenations,
      HistoryVisitorInfo,
      Evaluate
    },
    data() {
      return {
        currentPage: 1,
        dialogExportLoading: false,
        visitorExportLoading: false,
        pageSize: 10,
        serviceId: '',
        serviceList: [
          {csName: '全部客服', csId: ''}
        ],
        tagName: '',
        tagId: null,
        content:'',
        tagsList: [
          {label: '全部', tagName: '', tagId: ''}
        ],
        selectTime: '',
        vistorName: '',
		visitorAccessOrder: '',
        tableData: [],
        initTableData: [],
        total: 0,

        contactVisitorAuth: false,
        contactVisitorVisible: false,
        contactVisitorTitle: '编辑',
        visitorPhone: '',
        sendMsgData: {
          content: ""
        },
        startTime: '',
        endTime: '',
        historyLoading: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
          }
        },
        chatItem: '', //查看当前选中访客历史纪录数据
        isShow: false, //是否展开当前选中访客历史纪录
        isShowEvaluation: false, //是否展开当前选中访客评价
        evaluateData: '',

        /**
         * 获取访客头像，目前是直接引入项目图片文件夹中的图片
         * 没有使用绝对地址，后期如果更换为阿里云地址，该数据可不需要
         */
        avatarIMG: { //访客头像
          avatar0: avatar0,
          avatar1: avatar1,
          avatar2: avatar2,
          avatar3: avatar3,
          avatar4: avatar4,
          avatar5: avatar5,
          avatar6: avatar6,
          avatar7: avatar7
        },
        avatarDevice: { //设备头像
          device0: unknown,
          device1: device1,
          device2: device2,
          device3: device3,
          device4: device4,
          device5: device5
        },
        avatarSystem: { //系统头像
          system0: unknown,
          system1: system1,
          system2: system2,
          system3: system3
        },
        externalLinkList: [], // 白名单(防外链)列表
        searchRecordUserList:[],//历史聊天记录
        chatShowPop:false,//历史聊天记录窗口
        searchRecordNoMore: false,
        searchRecordListPage:1,
      }
    },
    computed: {
      userAuth() {
        return this.$store.state.user.isAuth
      }
    },
    created() {
      this.getHistoryData()
      this.getContactAuth()
      this.getServiceList()
      this.getAllTagList()
	  this.getExternalLinkList()
    },
    mounted() {

    },
    filters: {
      /**
       * 【访客来源】
       */
      formatSource: (value) => {
        switch (value) {
          case 'wfx':
            return '微分销'
            break
          case 'wxapp':
            return '小程序'
            break
          case 'wxgzh':
            return '公众号'
            break
          case 'home':
            return '官网'
            break
          case 'weibo':
            return '微博'
            break
          default :
            return '--'
            break
        }
      }
    },
    methods: {
	 //  根据访客数量排序
	  sortChange(e) {
		if (e.prop === 'visitNum') {
			if (e.order === 'descending') {
				this.visitorAccessOrder = 'DESC'
			} else if (e.order === 'ascending') {
				this.visitorAccessOrder = 'ASC'
			} else {
				this.visitorAccessOrder = ''
			}
		}
	  	
	  	this.getHistoryData()
	  },
      /**
       * 表单操作
       * @param val
       */
      handleOperate(val) {
        this.isShow = true
        this.chatShowPop = false
        this.isShowEvaluation = false
        this.chatItem = val
        this.chatItem.tags.forEach(item => {
          item.colorName = item.tagColor
          item.id = item.onlineVisitorTagEntity.tagId
          item.text = item.onlineVisitorTagEntity.tagName
        })
      },
      evaluateHandleOperate(val) {
        this.isShowEvaluation = true
        this.isShow = false
        this.evaluateData = val
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
		this.visitorAccessOrder = ''
		this.$refs.sort.clearSort()
        this.getHistoryData()
      },
      renderSex(name, value) {
        if (name == '性别') {
          switch (value) {
            case 0:
            case '0':
              return '未知';
            case 1:
            case "1":
              return '男';
            case 2:
            case "2":
              return '女';
          }
        } else {
          return value
        }

      },
      /**
       *
       * 获取历史数据
       * */
      getHistoryData() {
        this.historyLoading = true
        this.$http.getHistoryDataAPI({
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          vistorName: this.vistorName,
          serviceId: this.serviceId,
          start_time: this.startTime,
          end_time: this.endTime,
          tagId: this.tagId,
		  visitorAccessOrder: this.visitorAccessOrder
        }).then(res => {
          if (res.status == 1) {

            this.tableData = res.data.calling_list
            this.initTableData = res.data.calling_list
            this.total = res.data.hisCount
          }
          this.historyLoading = false
        }).catch(res => {
          this.historyLoading = false
        })
      },
      /**
       * 获取客服类型列表
       * */
      getServiceList() {
        this.$http.getAllServiceHisAPI().then(res => {
          if (res.status == 1) {
            this.serviceList = this.serviceList.concat(res.data.csList)
          }
        }).catch(err => {

        })
      },
      /**
       * 获取标签
       * */
      getAllTagList() {
        this.$http.getAllTagListAPI().then(res => {
          if (res.status == 1) {
            let tagData = res.data
            tagData.map(item => {
              item.label = item.tagName
            })
            this.tagsList = this.tagsList.concat(tagData)
          }
        }).catch(err => {

        })
      },
      getContactAuth() {
        this.$http.joinGetQQAndQRCodeConfigAPI().then(res => {
          if (res.status == 1) {
            this.contactVisitorAuth = res.data.isRelateVisitor
          }
        })
      },
      filterData() {
        this.visitorAccessOrder = ''
        this.$refs.sort.clearSort()
        this.currentPage = 1 // 上面的搜索条件改变重置为第一页
        this.getHistoryData()
      },
      changeContent(){
        if(this.content == ""){
          this.chatShowPop = false
        }
      },
    seachChatData(val){
      if(val == 1){
        this.searchRecordListPage = 1
        this.searchRecordUserList = []
      }
      this.historyLoading = true
       let params = {
          pageNum: this.searchRecordListPage?this.searchRecordListPage:0,
          pageSize: 3,
          vistorName: this.vistorName,
          serviceId: this.serviceId,
          start_time: this.startTime,
          end_time: this.endTime,
          tagId: this.tagId,
          content:this.content,
		      csType: 0
        }
        this.$http.queryMsgRecord(params).then(res => {
          if (res.status == 1) {
            this.chatShowPop = true
            this.searchRecordUserList = this.searchRecordUserList.concat(res.data.calling_list)
            if(res.data.calling_list.length < 3 && res.data.pageSize == 1){
              this.searchRecordNoMore = true 
            }else if(res.data.calling_list.length <3){
              this.searchRecordNoMore = true
            }else{
              this.searchRecordNoMore = false
            }
          }
          this.historyLoading = false
        }).catch(res => {
          this.historyLoading = false
        })
    },
    RecordSearchGetMore() {
      this.searchRecordListPage++;
      this.seachChatData(2);
    },
    // 选择一条搜索结果
    searchResultItem(item) {
      this.isShow = true
      this.chatShowPop = false
      this.chatItem = item
      // console.log(this.chatItem)
      // 点击搜索结果以后 搜索结果清空
      this.searchRecordUserList = []
    },
	  getExternalLinkList() {
	    this.$http.externalLinkListAPI().then(res => {
	      console.log(res)
	      if (res.status == 1) {
	        if (res.data.length) {
	          res.data.length ? Cookies.set('externalLinkList',JSON.stringify(res.data)) : ''
			  this.externalLinkList = res.data
	        }
	      }
	    })
	  },
      /**
       * 显示访客头像
       * 截取头像名称中的数字
       */
      avatarX(avatar) {
        if (!avatar) {
          return false
        }
        let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, 'g')
        if (reg.test(avatar)) {
          return avatar;
        } else {
          const img = avatar.substring(avatar.length - 5, avatar.length - 4)
          switch (img) {
            case 'y':
              return this.avatarIMG.avatar0
              break
            case '1':
              return this.avatarIMG.avatar1
              break
            case '2':
              return this.avatarIMG.avatar2
              break
            case '3':
              return this.avatarIMG.avatar3
              break
            case '4':
              return this.avatarIMG.avatar4
              break
            case '5':
              return this.avatarIMG.avatar5
              break
            case '6':
              return this.avatarIMG.avatar6
              break
            case '7':
              return this.avatarIMG.avatar7
              break
            default:
              return avatar
              break
          }
        }

      },
      /**
       * 【显示客服头像】
       */
      avatarM(avatar) {
        let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, 'g')
        if (reg.test(avatar)) {
          return avatar;
        } else {
          return avatar0
        }
      },
      /**
       * 【显示设备头像】
       */
      avatarDev(avatar) {
        if (!avatar) avatar = 'other'
        switch (avatar) {
          case 'other':
            return this.avatarDevice.device0
            break
          case 'chrome-mobile':
            return this.avatarDevice.device1
            break
          case 'safari-mobile':
            return this.avatarDevice.device2
            break
          case 'firefox-mobile':
            return this.avatarDevice.device3
            break
          case 'wechat':
            return this.avatarDevice.device5
            break
          default :
            return this.avatarDevice.device0
            break
        }
      },
      /**
       * 【显示系统头像】
       */
      avatarSys(avatar) {
        if (!avatar) avatar = 'other'
        switch (avatar) {
          case 'other':
            return this.avatarSystem.system0
            break
          case 'windows':
            return this.avatarSystem.system1
            break
          case 'ios':
            return this.avatarSystem.system2
            break
          case 'android':
            return this.avatarSystem.system3
            break
          default :
            return this.avatarSystem.system0
            break
        }
      },
      /**
       * Author: brand
       * Creation Time: 2019-04-26 10:56
       * Description: 主动联系访客方式
       */
      sendMsgToVisitorWay(params) {
        let type = params.type
        let data = params.data.visitorinfo
        this.contactInfo = params.data
        this.visitorPhone = ''
        if (type == 'dx' && data.phone == '') {
          this.$message({
            message: '未找到该访客手机号',
            type: 'warning',
            duration: 2000
          })
          return false
        }
        if (type == 'sc' && (data.source_qk == 'wxapp' || data.source_qk == 'wxgzh')) {
          this.$message({
            message: '公众号和小程序访客不能通过此方式联系',
            type: 'warning',
            duration: 2000
          })
          return false
        }
        if (type == 'xcx' && (data.source_qk != 'wxapp' || data.source_qk == 'wxgzh')) {
          this.$message({
            message: '非小程序访客不能通过小程序联系',
            type: 'warning',
            duration: 2000
          })
          return false
        }
        if (type == 'gzh' && (data.source_qk != 'wxgzh' || data.source_qk == 'wxapp')) {
          this.$message({
            message: '非公众号访客不能通过公众号联系',
            type: 'warning',
            duration: 2000
          })
          return false
        }
        this.sendMsgData.type = type
        switch (type) {
          case 'dx':
            this.contactVisitorTitle = '编辑短信'
            this.sendMsgData.phone = data.phone
            this.visitorPhone = data.phone
            break
          case 'sc':
            this.contactVisitorTitle = '编辑商城消息'
            break
          case 'gzh':
            this.contactVisitorTitle = '编辑微信公众号消息'
            break
          case 'xcx':
            this.contactVisitorTitle = '编辑小程序消息'
            break
        }
        this.contactVisitorVisible = true
      },
      /**
       * Author: brand
       * Creation Time: 2019-05-07 10:56
       * Description: 发送消息
       */
      sendMsgToVisitor() {
		let reg = /&nbsp;/g;
		let textArea = this.sendMsgData.content.replace(reg, "").trim()
		let canSend = true
		if (this.externalLinkList.length) {
		  this.externalLinkList.forEach(item => {
		    if (textArea.indexOf(item.externalLink) > -1) {
		      this.$message.error('请勿发送包含外链的文本信息')
		      canSend = false
		    }
		  })
		}
		if (!canSend) {
		  return false
		}
        let type = this.sendMsgData.type
        if (this.sendMsgData.content.trim().length === 0) {
          this.$message({
            message: '消息内容不能为空',
            type: 'error',
            duration: 2000
          })
          return false
        }
        if (type == 'dx') {
          this.$http.contactVisitorByMsg(this.sendMsgData).then(res => {
            if (res.status == 1) {
              this.$message({
                message: '消息发送成功',
                type: 'success',
                duration: 2000
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              })
            }
          }).catch(err => {
            console.log('err=', err)
          })
        } else {
          delete this.sendMsgData.phone
          const postData = {
            'messagesId': this.contactInfo.messageId,
            'visitorId': this.contactInfo.onlineVisitorEntity.visitorId,
            'msgType': 'text',
            'talk_time': '0',
            'callingNo': this.contactInfo.callingNo,
            'text': this.sendMsgData.content
          }
          this.$http.getReplyHandler(postData)
            .then(res => {
              if (res.status == 1) {
                this.$message({
                  message: '消息发送成功',
                  type: 'success',
                  duration: 2000
                })
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                })
              }
            })
        }
        this.contactVisitorVisible = false
        this.sendMsgData = {
          content: ''
        }
      },
      /**
       * 时间选择
       */
      timeSelect() {
        if (this.selectTime) {
          this.startTime = this.selectTime[0]
          this.endTime = this.selectTime[1]
        } else {
          this.startTime = ''
          this.endTime = ''
        }

        this.$nextTick(() => {
          this.filterData()
        })
      },
      /**
       * 【展开/关闭历史数据】
       */
      historyShowHandler(msg) {
        this.isShow = msg
      },
      /**
       * 【展开/关闭评价】
       */
      evaluateShowHandler(msg) {
        this.isShowEvaluation = msg
        this.tableData = this.initTableData
      },
      dialogExport() {
        if (this.startTime.length == 0 || this.endTime.length == 0) {
          this.$message({
            message: '请选择导出时间',
            type: 'error',
            duration: 2000
          })
          return false
        }
        let exportParams = {
          csId: this.serviceId, //this.$store.state.user.userInfo.csId,
          startTime: this.startTime,
          endTime: this.endTime,
          visitorName: this.vistorName,
        }
        var params = Object.keys(exportParams).map(function (key) {
          // body...
          return encodeURIComponent(key) + "=" + encodeURIComponent(exportParams[key]);
        }).join("&");
        let exportUrl = process.env.VUE_APP_API_URL + '/wlapi/history/dialogueOutExcel?' + params
        window.open(exportUrl)
      },
      visitorInfoExport() {
        if (this.startTime.length == 0 || this.endTime.length == 0) {
          this.$message({
            message: '请选择导出时间',
            type: 'error',
            duration: 2000
          })
          return false
        }
        let exportParams = {
          csId: this.serviceId, // this.$store.state.user.userInfo.csId,
          visitorName: this.vistorName,
          startTime: this.startTime,
          endTime: this.endTime,
        }
        var params = Object.keys(exportParams).map(function (key) {
          // body...
          return encodeURIComponent(key) + "=" + encodeURIComponent(exportParams[key]);
        }).join("&");
        let exportUrl = process.env.VUE_APP_API_URL + '/wlapi/history/historyOutExcel?' + params
        window.open(exportUrl)
      },
	  /**
	   * 访客信息改变 
	   */
	  refreshVisitorInfo(msg){
	  	this.chatItem.visitorinfo = msg
	  },
	  /**
	   * 加入黑名单 
	   */
	  addBlackList(id){
		let _this = this
		this.$confirm('此操作会将当前访客加入黑名单, 是否继续?', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning'
		}).then(() => {
		  _this.$http.addBlackListAPI({uid:id}).then(res => {
		  	if (res.status == 1) {
			  _this.getHistoryData()
		  	  _this.$message({
		  		message: '加入黑名单成功',
		  		type: 'success',
		  		duration: 2000
		  	  })
		  	} else {
		  	  _this.$message({
		  		message: res.msg,
		  		type: 'error',
		  		duration: 2000
		  	  })
		  	}
		  })
		})
	  	
	  },
	  /**
	   * 移除黑名单
	   */
	  removeBlackList(id) {
	    let _this = this
	    this.$confirm('此操作会将当前访客移除黑名单, 是否继续?', '提示', {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	      _this.$http.removeBlackListAPI({uid:id}).then(res => {
	      	if (res.status == 1) {
	    	  _this.getHistoryData()
	      	  _this.$message({
	      		message: '移除黑名单成功',
	      		type: 'success',
	      		duration: 2000
	      	  })
	      	} else {
	      	  _this.$message({
	      		message: res.msg,
	      		type: 'error',
	      		duration: 2000
	      	  })
	      	}
	      })
	    })
	  },
    }
  }
</script>

<style lang="scss">
  .visitor-info-container .info-item .item-left {
    width: 85% !important;
  }

  .visitor-info-container .info-item .item-label {
    width: 60px !important;
    text-align: right;
  }

  .history-index {
    .topSeach{
      position: relative;
      display: inline-block;
      .chatBox{
        width: 230px;
        padding-top: 16px;
        height: 270px;
        overflow-y:scroll;
        background: #fff;
        position: absolute;
        z-index: 1000;
        box-shadow: 2px 2px 2px #ebebeb;
        .search-result-item {
              padding: 0 11px;
              box-sizing: border-box;
              &.search-tag {
                .tag {
                  background: #fff;
                  border: 1px solid #d5d5d5;
                  color: #d5d5d5;
                }
              }
              .search-result-list-box{
                margin-left: -35px;
                .search-result-list-item {
                  display: flex;
                  box-sizing: border-box;
                  cursor: pointer;

                  &.no-search-result {
                    display: block;
                    text-align: center;
                    line-height: 50px;
                  }

                  .search-result-avatar {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin: 11px 9px 11px 0;

                    img {
                      width: 100%;
                      height: 100%;
                      border-radius: 50%;
                    }
                  }

                  .search-result-content-box {
                    flex: 1;
                    border-bottom: 1px solid #eee;
                    padding: 11px 0;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    overflow: hidden;
                    position: relative;
                    color: #808080;
                    font-size: 12px;

                    .search-result-chat-time {
                      position: absolute;
                      right: 5px;
                      top: 15px;
                    }

                    .search-result-username {
                      &.chatting {
                        width: 85px;
                      }

                      color: #010101;
                      font-size: 14px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }

                    .search-result-usertag {
                      padding-top: 3px;

                      .search-result-tag {
                        padding: 0 10px;
                        margin-bottom: 3px;
                      }
                    }

                    .search-result-chat-content {
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                  }

                  &:last-child {
                    .search-result-content-box {
                      border: none;
                    }
                  }
                }
              }
              
            }
      }
    }
    .module-item-style{
      width: calc(100% - 100px);
    }
    .visit-info {
      .item-info-wrapper {
        display: inline-block;
        width: 68%;
        vertical-align: top;
        margin-left: 10px;
        border-right: 1px solid #ddd;
      }

      &-left {
        display: inline-block;
        width: 50%;
        vertical-align: top;

        .agentImg {
          display: inline-block;
        }

        .item-label {
          display: inline-block;
        }

        .item-value {
          display: inline-block;
        }
      }

      &-right {
        display: inline-block;
        width: 50%;
      }
    }

    .evaluater-rate {
      .el-rate__item {
        cursor: pointer !important;
      }
    }

    .history-search-container {
      display: flex;

      & > div {
        margin-right: 20px;
      }

      .service-search-input {
        width: 300px;
      }

      .export-data-container {
        margin-left: auto;
        display: flex;

        & > div {
          width: 112px;
        }

        & > div + div {
          margin-left: 20px;
        }
      }
    }

    .history-table-box {
      height: calc(100% - 105px);

      .chatCss {
        width: 40% !important;

        .el-pagination__total, .el-pagination__sizes, .el-pagination__jump {
          display: none;
        }
      }

      .EvaluationCss {
        width: 50% !important;

        .el-pagination__total, .el-pagination__sizes, .el-pagination__jump {
          display: none;
        }
      }

      .source {
        display: inline-block;
        text-align: center;

        .source_from {
          font-size: 12px;
          padding: 0 2px;
          height: 18px;
          line-height: 18px;
          border-radius: 2px;

          &.wfx {
            color: #3296fa;
            border: 1px solid #3296fa;
          }

          &.home {
            color: rgba(208, 13, 98, 0.8);
            border: 1px solid rgba(208, 13, 98, 0.8);
          }

          &.wxapp {
            color: #ff9c00;
            border: 1px solid #ff9c00;
          }

          &.wxgzh {
            color: #7bd239;
            border: 1px solid #7bd239;
          }
          &.weibo{
            color: #c15cd2;
            border: 1px solid #c15cd2;
          }
        }
      }

      .tb-btn {
        background: none;
        border: 1px solid #999999;
        color: #666;
        border-radius: 2px;
        font-size: 12px;
        width: 70px;
		line-height: 20px;
        cursor: pointer;
        outline: none;
        text-align: center;

        &.tb-btn-edit, &.tb-btn-operate {
          display: block;
          border-color: #428efe;
          color: #428efe;
        }

        &.tb-btn-del {
			display: block;
			&.danger{
				border: 1px solid #F56C6C;
				color: #F56C6C;
			}
        }
      }

      .info-wrap {
        display: flex;
        align-items: center;
        cursor: pointer;

        .wrap-display {
          display: flex;
        }

        .wrap-left-info {
          width: 48%;

          overflow: hidden;
          border-right: 1px solid #ccc;
          padding-right: 2%;
        }

        .wrap-right-info {
          width: 100%;
          padding-left: 3%;
          overflow: hidden;
          display: flex;
          align-items: center;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .agentImg {
        display: inline-block;
        width: 30px;
        height: 30px;

        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }

      .agentName {
        line-height: 30px;
        margin-left: 10px;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .visitorImg {
        display: inline-block;
        margin: 0 5px;
        line-height: 30px;

        img {
          width: 18px;
          height: 18px;
          vertical-align: middle;
        }
      }

      .tag {
        margin-bottom: 8px;
      }
    }

    .contact-visitor-content {
      width: 100%;
      border: 1px solid #eee;
      padding: 6px;
      box-sizing: border-box;
      outline: none;
      resize: none;
    }

    .pannelBox {
      position: absolute;
      top: 0;
      right: 1px;
      bottom: 1px;
      width: 70%;
      z-index: 99;
      border-top: 1px solid #E5E5E5;
      border-left: 1px solid #E5E5E5;
      box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.3);
      transition: width .3s linear;
      background: #fff;
    }

    .evaluatePannelBox {
      position: absolute;
      top: 0;
      right: 1px;
      bottom: 1px;
      width: 50%;
      z-index: 10;
      border-top: 1px solid #E5E5E5;
      border-left: 1px solid #E5E5E5;
      box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.3);
      transition: width .3s linear;
      background: #fff;
    }
	.el-date-editor.el-input, .el-date-editor.el-input__inner{
		width: 270px!important;
	}
  }
</style>
